import { render, staticRenderFns } from "./PrefixHome.vue?vue&type=template&id=a57b0880&"
import script from "./PrefixHome.vue?vue&type=script&lang=js&"
export * from "./PrefixHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports